import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import { Filter, FilterReportData } from '../../../components/Reports/Filter';
import { ReportByInspectionType } from '../../../components/ReportByInspectionType/ReportByInspectionType';
import { ReportInspected } from '../../../../common/types/ReportTypes';

export const ReportConductedInspectionsCPRView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<FilterReportData | undefined>(
    {},
  );
  const [data, setData] = useState<ReportInspected>({
    details: {},
    sum: {},
  });

  const onSearch = (filter?: FilterReportData) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports
      .reportConductedInspections(true, filter)
      .then(dataReports => {
        setData(dataReports);
      });
  };

  return (
    <>
      <Filter
        onSearch={onSearch}
        reportName="Liczba przeprowadzonych kontroli CPR"
      />
      <ReportByInspectionType
        data={data}
        reportName="Liczba przeprowadzonych kontroli CPR"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
      />
    </>
  );
};
